import type {RouteParams} from 'types/routes'
import {WITH_AUTH_ADMIN_PATHS} from 'consts/paths'
import {Index} from 'pages/withAuth/adminPage/procedureStatuses/chooseProcedure'
import {Attachments} from 'pages/withAuth/adminPage/procedureStatuses/[id]/attachments'
import {EgovPrepare} from 'pages/withAuth/adminPage/procedureStatuses/[id]/egov/prepare'
import {R510ImportPayments} from 'pages/withAuth/adminPage/procedureStatuses/[id]/r510ImportPayments'

export const ProcedureStatusRoutes: RouteParams[] = [
  {
    key: 'procedure_statuses/choose_procedures',
    path: WITH_AUTH_ADMIN_PATHS.PROCEDURE_STATUSES.CHOOSE_PROCEDURE,
    component: Index,
    exact: true,
    whiteList: ['full_admin', 'office_admin', 'limited_admin'],
  },
  {
    key: 'procedure_statuses/:id/attachments',
    path: WITH_AUTH_ADMIN_PATHS.PROCEDURE_STATUSES.PROCEDURE_STATUS_ID.ATTACHMENTS,
    component: Attachments,
    exact: true,
    whiteList: ['full_admin', 'office_admin', 'limited_admin'],
  },
  {
    key: 'procedure_statuses/:id/egov/prepare',
    path: WITH_AUTH_ADMIN_PATHS.PROCEDURE_STATUSES.PROCEDURE_STATUS_ID.EGOV.PREPARE,
    component: EgovPrepare,
    exact: true,
    whiteList: ['full_admin', 'office_admin', 'limited_admin'],
  },
  {
    key: 'procedure_statuses/:id/r510_import_payments',
    path: WITH_AUTH_ADMIN_PATHS.PROCEDURE_STATUSES.PROCEDURE_STATUS_ID.R510_IMPORT_PAYMENTS,
    component: R510ImportPayments,
    exact: true,
    whiteList: ['full_admin', 'office_admin', 'limited_admin'],
  },
]
